import { render, staticRenderFns } from "./responsible.vue?vue&type=template&id=80122dcc&scoped=true&"
import script from "./responsible.vue?vue&type=script&lang=js&"
export * from "./responsible.vue?vue&type=script&lang=js&"
import style0 from "./responsible.vue?vue&type=style&index=0&id=80122dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80122dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80122dcc')) {
      api.createRecord('80122dcc', component.options)
    } else {
      api.reload('80122dcc', component.options)
    }
    module.hot.accept("./responsible.vue?vue&type=template&id=80122dcc&scoped=true&", function () {
      api.rerender('80122dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/olap-reports/components/responsible.vue"
export default component.exports